import { Badge } from "~/components/Badge";
import { RWA_COIN_ICON } from "~/consts";
import { ImageLoader } from "~/components/ImageLoader";
import { Tooltip } from "~/components/Tooltip";
import { cn } from "~/lib/utils";

// // // //

function NetworkBadgeContent(props: {
    network: {
        slug: string;
        name: string;
        icon_url: string | null;
        icon_css?: string;
    };
    stacked: boolean;
}) {
    const { network, stacked } = props;

    const icon_css = network.icon_css || "h-5 w-5 min-w-5";

    if (network.icon_url) {
        return (
            <ImageLoader
                src={network.icon_url as string}
                className={cn(
                    "rounded-full relative inline-block bg-card",
                    icon_css,
                    {
                        "z-10": stacked,
                    },
                )}
                alt={`${network.name} Logo`}
                fallbackSrc={RWA_COIN_ICON}
                fallbackClassName="p-0.5"
            />
        );
    }

    return (
        <Badge
            rounded="full"
            className="relative z-10 inline-block h-5 w-5"
            variant="blue"
            label={network.name[0]}
        />
    );
}

export function NetworkBadge(props: {
    network: {
        slug: string;
        name: string;
        icon_url: string | null;
        icon_css?: string;
    };
    enableTooltip?: boolean;
    isLink?: boolean;
}) {
    const { network, enableTooltip = true, isLink = true } = props;

    if (!enableTooltip) {
        return <NetworkBadgeContent stacked={false} network={network} />;
    }

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                <div className="px-3 py-1.5">
                    <p className="whitespace-nowrap text-sm">{network.name}</p>
                    {isLink && (
                        <p className="whitespace-nowrap text-xs">
                            Click to view {network.name} page
                        </p>
                    )}
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <span ref={setTriggerRef}>
                    <NetworkBadgeContent stacked network={network} />
                </span>
            )}
        </Tooltip>
    );
}
